import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Typography, TextField } from '@mui/material'
import cards from '../util/cards'
import dateHandler from '../../utils/dateHandler'
import moment from 'moment'

const DateSelect = ({ startDate, setStartDate, errors }) => {
  const dispatch = useDispatch()

  let isSignedIn = useSelector((state) => state.login.isLoggedIn)
  const confirmed = useSelector((state) => state.cart.dateConfirmed)
  let today = new Date().toISOString().split('T')[0]

  const [error, setError] = useState(false)

  const BlankCard = cards.blankCard

  const handleChange = (e) => {
    setStartDate(e.target.value)
  }

  // const handleConfirm = () => {
  //   if (date === '') {
  //     setStartDate(today)
  //     // dispatch(setDateConfirmed(true))
  //     setError(false)
  //   } else {
  //     if (
  //       dateHandler.isOverFiveDaysFromNow(date) ||
  //       dateHandler.isToday(date)
  //     ) {
  //       setStartDate(date)
  //       // dispatch(setDateConfirmed(true))
  //       setError(false)
  //     } else {
  //       setError(true)
  //     }
  //   }
  // }

  // const handleUndo = () => {
  //   setDate('')
  //   setStartDate('')
  //   dispatch(setDateConfirmed(false))
  // }

  return (
    <>
      {isSignedIn ? (
        <>
          <div style={{ display: 'flex' }}>
            <Typography
              variant={'h4'}
              sx={{ paddingTop: '10px', marginRight: '10px' }}
            >
              3. Start Date
            </Typography>
            <Typography
              variant='caption'
              align='center'
              style={{ marginTop: '25px' }}
            >
              (leave unchanged if starting within five days)
            </Typography>
          </div>

          <BlankCard>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {confirmed ? (
                <Typography variant='h6'>{startDate}</Typography>
              ) : (
                <TextField
                  fullWidth
                  type={'date'}
                  onChange={(e) => handleChange(e)}
                  error={errors.includes('dateWithinFiveDays') || errors.includes('dateInThePast')}
                  helperText={
                    errors.includes('dateWithinFiveDays')
                      ? `If not today's date, your selection must be at least five days in the future`
                      : errors.includes('dateInThePast')
                      ? 'Date cannot be in the past.'
                      : ''
                  }
                  value={startDate}
                />
              )}
            </div>
          </BlankCard>
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default DateSelect
